import { ActionTree } from 'vuex'
import { PointsOfInterest } from './types'
import { RootState } from '../types'
import { GlobalHelpers, PointsOfInterestHelpers } from '@/helpers/mainExports'

export const actions: ActionTree<PointsOfInterest, RootState> = {
	filterPointsOfInterestByString({ state, commit }, { string }) {
		if (string.length > 2) {
			const filterPointsOfInterest = state.pointsOfInterest.filter(poi => poi.label.toLowerCase().match(string))
			commit('setFilterPointsOfInterestByString', { filterPointsOfInterest })
		} else commit('resetFilterPointsOfInterestState')
	},
	async showPointsOfInterest({ commit, getters, dispatch }, { map, pointsInStorage }) {
		commit('setShowPointsOfInterestLoadingButton')
		if (!getters.showPointsOfInterestOnMap) {
			const promisesPointsSelected: any = []

			const pointsStoragePartition = GlobalHelpers.chunkArray(
				pointsInStorage,
				20
			)

			for (const pointsStorage of pointsStoragePartition) {
				for (const id of pointsStorage) {
					promisesPointsSelected.push(PointsOfInterestHelpers.getPointOfInterest(id))
				}

				const results: any = await Promise.allSettled(
					promisesPointsSelected
				)
				const pointsSelected = results.map((result: any) => {
					if (result.status === 'fulfilled') {
						const { value } = result

						Object.assign(value, { id: value.id })
						if (Boolean(value)) return value
						else return {}
					}
				})

				for (const p of getters.getPointsOfInterest) {
					for (const pointSelected of pointsSelected) {
						if (pointSelected.id === p.id) {
							Object.assign(p, pointSelected)
						}
					}
				}
				
				PointsOfInterestHelpers.pointsOnMap(pointsSelected, map)
			}
		} else {
			dispatch('destroyPointsOfInterestOnMap')
		}
		commit('setShowPointsOfInterestLoadingButton')
	},
	destroyPointsOfInterestOnMap({ commit, getters }) {
		getters.getPointsOfInterestOnMap.forEach(pointOnMap => {
			pointOnMap.setMap(null)
		});
		commit('destroyPointsOfInterestOnMap')
	},
	async activateAllPointsSelected(
		{ getters, dispatch, commit },
		{ map }
	) {
		commit('setShowPointsOfInterestLoadingButton')		
		const pointsId = getters.getPointsOfInterest.map(point => point.id)
		localStorage.setItem('pointsOfInterestSelectedLt', JSON.stringify(pointsId))
		try {
			const promisesPointsPartition: any = []

			const pointPartition = GlobalHelpers.chunkArray(
				getters.getPointsOfInterest,
				20
			)

			for (const pointPart of pointPartition) {
				for (const point of pointPart) {
					promisesPointsPartition.push(
						PointsOfInterestHelpers.getPointOfInterest(point.id)
					)
				}

				const results: any = await Promise.allSettled(
					promisesPointsPartition
				)

				const pointResults = results.map((result: any) => {
					if (result.status === 'fulfilled') {
						const { value } = result
						Object.assign(value, { id: value.id })
						if (Boolean(value)) return value
						else return {}
					}
				})

				for (const point of getters.getPointsOfInterest) {
					for (const pointCoord of pointResults) {
						if (pointCoord.id === point.id) {
							point.geometry.coordinates = pointCoord.geometry.coordinates
							point.hidePoint = false
						}
					}
				}
			}

			const pointsOfInterestSelectedLt = JSON.parse(JSON.stringify(getters.getPointsOfInterest))
			dispatch('destroyPointsOfInterestOnMap')

			PointsOfInterestHelpers.pointsOnMap(pointsOfInterestSelectedLt, map)
		} catch (e) {
			console.error(e)
		}
		commit('setShowPointsOfInterestLoadingButton')
	},
}
